(function (TIPTOE, window, document, $) {
  const $form = $('#form-share');

  // Hide errors
  $form.on('focus', 'input', function (e) {
    $(this).parent('.form__group').removeClass('has-error').find('.form-share__error').html('');
  });

  // Submission
  $form.on('submit', function (e) {
    e.preventDefault();
    $form.find('.btn--share').addClass('is-loading');

    // Callling maybe
    $.ajax({
      url: window.wp.ajax.settings.url,
      type: 'POST',
      data: $form.serialize(),
    })
      .done(function (response) {
        console.log('success');
        console.log(response);

        // Errors
        if (response.hasError) {
          $.each(response.errors, function (name, value) {
            if (name === 'global') {
              $form.find('#form-share__error--global').html(value);
            } else {
              $form
                .find(`input[name="${name}"]`)
                .parent('.form__group')
                .addClass('has-error')
                .find('.form-share__error')
                .html(value);
            }
          });
        } else {
          // Success
          $form.find('.btn--share .btn__label').html(response.data);
        }
      })
      .fail(function (xhr, textStatus, errorThrown) {
        console.log(xhr, textStatus, errorThrown);
      })
      .always(function () {
        $form.find('.btn--share').removeClass('is-loading');
      });
  });

  // Display pop-in
  $('#js-mailto-friend').click(function () {
    $form.addClass('is-visible');
  });

  // Close
  $('#js-close-mailto-friend').click(function () {
    $form.removeClass('is-visible');
  });
})(TIPTOE, window, document, jQuery);
